import React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import { device } from '../../../utils/helpers'

const link = css`
  text-decoration: none;
`

const TabWrapperBase = styled.div`
  background-color: ${props => props.active ? props.theme.color.bgYellow : '#f3f3f3'};
  padding-top: 10px;
  padding-bottom: 10px;
  align-items: center;
  width: 180px;
  justify-content: ${props => props.tabCount < 3 ? 'center' : 'space-between'};
  text-align: center;
  border: 5px solid ${props => props.active ? props.theme.color.bgYellow : '#f3f3f3'};
  cursor: pointer;
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  outline: none;
  color: ${props => props.active ? '#fff' : '#4d4d4d'};
  line-height: 1.2em;
  margin: 0 2.5px;
  font-size: 12px;

  @media ${device.tablet} {
    padding-top: 1.0416666666666667vw;
    padding-bottom: 0.78125vw;
    width: 20.833333333333336vw;
    font-size: 1.25vw;
  }

  ${'' /* @media ${device.laptop} {
    width: 200px;
  }

  @media ${device.laptopM} {
    width: 235px;
  }

  @media ${device.laptopL} {
    width: 305px;
  }

  @media (min-width: 1770px) {
    width: 407px;
    padding-top: 20px;
    padding-bottom: 15px;
  } */}

  &:hover {
    background-color: ${props => props.theme.color.bgYellow};
    border: 5px solid ${props => props.theme.color.hoverPrimary};
    color: #fff;
  }
`

const TabWrapperLink = TabWrapperBase.withComponent(Link).extend`
  ${link}
`

const Tab = ({ to, children, active, ...props }) => {
  // If link return Link component
  if (to) {
    return (
      <TabWrapperLink to={to} active={active} {...props}>
        {children}
      </TabWrapperLink>
    )
  }

  return (
    <TabWrapperBase active={active} {...props}>
      {children}
    </TabWrapperBase>
  )
}

export default Tab



// WEBPACK FOOTER //
// ./src/components/Calculator/Tabs/Tab.js